import React, { useState } from 'react';
import TGECard from './TGECard';
import Leaderboard from './Leaderboard';
import Rules from './Rules';
import AdminPanel from './AdminPanel';
import { useAuth } from '../contexts/AuthContext';

const Dashboard: React.FC = () => {
  const [activeTab, setActiveTab] = useState('tges');
  const { currentTeamMember } = useAuth();

  const tabs = [
    { id: 'tges', label: 'TGEs', icon: '🎯' },
    { id: 'leaderboard', label: 'Leaderboard', icon: '🏆' },
    { id: 'rules', label: 'Rules', icon: '📋' },
    { id: 'admin', label: 'Admin', icon: '⚙️' }
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'tges':
        return <TGECard />;
      case 'leaderboard':
        return <Leaderboard />;
      case 'rules':
        return <Rules />;
      case 'admin':
        return <AdminPanel />;
      default:
        return <TGECard />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-background-start via-background-middle to-background-end">
      <div className="container mx-auto px-4 py-8">
        {/* Personalized Greeting */}
        {currentTeamMember && (
          <div className="text-center mb-4">
            <h2 className="text-2xl font-semibold text-accent drop-shadow-glow animate-fade-in">
              Hello, {currentTeamMember.name}!
            </h2>
          </div>
        )}
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white mb-2">Token Launch League</h1>
          <p className="text-gray-300">Predict token valuations and compete for glory!</p>
        </div>

        {/* Tab Navigation */}
        <div className="flex flex-wrap justify-center mb-8">
          <div className="bg-background-middle/50 rounded-lg p-1 border border-primary/20">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`px-6 py-3 rounded-md font-medium transition-all duration-200 ${
                  activeTab === tab.id
                    ? 'bg-primary text-white shadow-lg transform scale-105'
                    : 'text-gray-300 hover:text-white hover:bg-background-middle/30'
                }`}
              >
                <span className="mr-2">{tab.icon}</span>
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Tab Content */}
        <div className="tab-content">
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};

export default Dashboard; 